import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {environment} from 'environments/environment';
import {ToastrService} from 'ngx-toastr';
import {Observable, catchError, tap, throwError} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    public user: any = null;

    constructor(
        private httpClient: HttpClient,
        private router: Router,
        private toastr: ToastrService
    ) {}
    //api url
    private apiUrl = environment.apiUrl;
    getUserList(
        name: string,
        phone: string,
        email: string,
        page: number,
        pageSize: number
    ): Observable<any> {
        return this.httpClient
            .post(`${this.apiUrl}/User/GetUserLists`, {
                name,
                phone,
                email,
                page,
                pageSize
            })
            .pipe(catchError(this.error));
    }

    getUserProfileById(userId: number): Observable<any> {
        return this.httpClient
            .get(`${this.apiUrl}/User/GetUserProfileById?id=${userId}`)
            .pipe(catchError(this.error));
    }
    updateUserProfile(model: any): Observable<any> {
        return this.httpClient
            .post(`${this.apiUrl}/User/UpdateUserProfile`, model)
            .pipe(catchError(this.error));
    }

    deleteUser(userId: number): Observable<any> {
        return this.httpClient
            .post(`${this.apiUrl}/User/DeleteUser?id=${userId}`, {})
            .pipe(catchError(this.error));
    }
    // Handle Errors
    error(error: HttpErrorResponse) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            errorMessage = error.error.message;
        } else {
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(() => {
            return errorMessage;
        });
    }
}
